import React from "react";
import { useNavigate } from "react-router-dom";

const IncidentDashboard = ({ incidentReports }) => {
  const navigate = useNavigate();

  return (
    <div className="dashboard">
      {incidentReports.map((report) => (
        <div key={report.id} className="incident-card">
          <h3>{report.employee?.name}</h3>
          <p>Status: {report.status}</p>
          <button
            className="secondary-button"
            onClick={() => navigate(`/incident-report/view/${report.id}`)}
          >
            View Report
          </button>
        </div>
      ))}
    </div>
  );
};

export default IncidentDashboard;
